import { isPlatformBrowser } from '@angular/common'
import { inject, Injectable, PLATFORM_ID } from '@angular/core'
import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { environment } from '@environments/environment'
import { AuthService } from '@shared/services/auth.service'

@Injectable({
  providedIn: 'root',
})
export class ErrorLogService {
  private httpClient = inject(HttpClient)
  private authService = inject(AuthService)
  private platformId = inject(PLATFORM_ID)

  log(error: any, failedUrl: string, method: string) {
    console.error(error)
    if (!isPlatformBrowser(this.platformId)) {
      return
    }

    const payload = {
      timestamp: new Date().toISOString(),
      level: 'warn',
      context: environment.appHost,
      request: {
        url: failedUrl,
        method: method,
      },
      response: {
        status: error?.status ?? 400,
        statusText: error?.statusText ?? '',
        body: error instanceof HttpErrorResponse ? error : error instanceof Error ? error.message : 'unexpected error',
      },
      clientInfo: {
        userAgent: navigator.userAgent,
        currentUrl: window.location.href,
        user: this.authService.customer()?.id ?? null,
      },
    }

    this.httpClient.post(`${environment.logApiUrl}/logs`, payload).subscribe({
      error: err => console.error('Failed to send log...', err),
    })
  }
}
